import {
  DashboardResponse,
  DashboardResponseError
} from '../models/dashboard.interfaces';

export const dashboardResponseErrorMocks: DashboardResponse =
  {} as DashboardResponse;

export const dashboardErrorMocks: DashboardResponseError = {
  code: '',
  description: '',
  inputParam: '',
  message: '',
  stackTrace: ''
};

export const dashboardResponseNotLoggedInMocks: DashboardResponse = {
  smNumber: '8006270311',
  firstName: 'Coco',
  lastName: 'Olive',
  smBalance: '820',
  membershipLevel: 'DM',
  enrollmentDate: '2014-05-27',
  prefix: 'Mr',
  primaryEmailAddress: 'test.tesing@delta.com',
  preferredName: 'FR',
  isAbove18: true,
  medallionMemberDesc: 'Diamond Medallion',
  medallionMbrInd: '1',
  country: 'US',
  language: 'EN',
  customerID: '0008006270311',
  MQMBalance: '0',
  loyaltyPromoInd: 'Y',
  loyaltyPromoLink: '/mypromos/displayPromotions',
  sysDrvdPrefHomeArptCd: 'MSP',
  usrProvdPrefHomeArptCd: 'JFK',
  crprtAgrmntId: '7814792|3000000008072|US123456789',
  crprtAgrmntTypeCode: 'CNA|CNA|SME',
  crprtPricingDiscCode: '579EQ00|4BW0F00| ',
  crprtName: '2CHECKOUT|GOOGLE|TAI',
  adminCompanyName: 'NA|NA|NA',
  smeCompanyName: 'tai',
  smeCardTypes: 'SKYB',
  skyPriority: true,
  pwmMbr: false,
  crprtAgrmntFound: true,
  skymilesMember: true,
  langPromptIndicator: false,
  rememberMeIndicator: false,
  millionMiler: false,
  irop: false,
  spgInd: false,
  firstTime: true,
  hasUserNm: false,
  is360Tier: false,
  promoCdInd: false,
  loggedIn: false,
  isWarmState: false,
  hasSQA: true,
  hasEmail: true,
  hasTripLink: 'N',
  hasNuTvl: 'N',
  hasPhone: true,
  permType: 'NA|NA|NA',
  pgmType: 'NA|NA|NA',
  accessToken: 'NA|NA|NA',
  userId: 'NA|NA|NA',
  program: 'NONE|CSA|SKYB',
  contractMgtEnt: 'NA|NAM|NA',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  formNameSubmitted: '',
  isEmailValid: true,
  middleName: '',
  milesExpireDate: '',
  millionMilerTier: '',
  nameSuffix: '',
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeLastName: '',
  spid: '',
  triplinkErrorCd: '',
  userNameType: '',
  venderID: '',
  isSkyClubMember: '',
  skyClubMemberType: '',
  skyClubMembershipDiscontinueDate: '',
  errors: [dashboardErrorMocks],
  emailAddressLocalDate: '2024-04-18',
  hasTravelPolicy: '',
  cobrandCardtypeAffiliationIdList: '840032888460:840052869646',
  cobrandCardtypeDescList:
    'Delta SkyMiles Reserve Card:Delta SkyMiles Reserve Business Card',
  cobrandCardtypeList: 'AXCV:AXBV',
  cobrandCardtypeSkyclubEligibleList: 'false:false'
};
